import { createAction } from '@reduxjs/toolkit'

export const HYDRATE = createAction('HYDRATE') as any